import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { BroadcastService } from '../../../../../shared/services/broadcast.service';
import { FormService } from '../../../../../shared/services/form.service';
import { takeUntil } from 'rxjs/operators';
import { LayoutModel } from '../models/layout.model';
import { ReelCategoriesService } from '../../../../../services/reel-categories.service';
import { LayoutsService } from '../../../../../services/layouts.service';

@Component({
  selector: 'app-create-edit-layout',
  templateUrl: './create-edit-layout.component.html',
  styleUrls: ['./create-edit-layout.component.scss']
})
export class CreateEditLayoutComponent implements OnInit, OnDestroy {
	@Input() data: any = {};
	formGroup: RxFormGroup;

	fields: any = {
		name: {
			type: 'input',
			options: {
				path: 'name',
				class: 'col-sm-12',
				label: {
					text: 'Nombre',
					class: 'col-sm-12'
				}
			}
		},
		json_data: {
			type: 'json_editor',
			options: {
				path: 'json_data',
				class: 'col-sm-12',
				label: {
					text: 'Codigo Json',
					class: 'col-sm-12'
				}
			}
		}
	};

	private atComponentDestroy = new Subject();

	constructor(
		private cdr: ChangeDetectorRef,
		public modalRef: BsModalRef,
		private broadcast: BroadcastService,
		private formService: FormService,
		private layoutsService: LayoutsService
	) {
		this.formService._formEvents
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(data => {
				this.formGroup = data;
			});
	}
	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.unsubscribe();
	}

	async ngOnInit(): Promise<void> {
		await this.formService.transformIntoFormGroup(LayoutModel, this.data);

		this.formGroup.valueChanges
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(data => {
				this.cdr.markForCheck();
			});
	}

	/**
	 * Send the data to the server
	 */
	submit(): void {
		this.layoutsService.createOrUpdate(this.formGroup, this.data?.id)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(
				data => {
					this.broadcast.reloadDataTable();
					this.modalRef.hide();
				}
			);
	}

	/**
	 * Helper function to transform an Object into an Array
	 * @param enumme
	 * @returns
	 */
	toArray(enumme): any[] {
		return Object.keys(enumme)
			.map(key => ({ id: key, name: enumme[key] }));
	}

}
